"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { WorkspaceElementType } from '@integration-app/sdk';
import { useElement } from '../useElement.mjs';

function useActionInstance(selector) {
  const {
    item: actionInstance,
    accessor,
    refresh,
    ...rest
  } = useElement(
    WorkspaceElementType.ActionInstance,
    selector,
    (integrationApp) => selector ? integrationApp.actionInstance(selector) : void 0
  );
  async function run(input) {
    return accessor?.run(input);
  }
  async function setup() {
    await accessor?.setup();
    await refresh();
  }
  async function reset() {
    await accessor?.reset();
    await refresh();
  }
  async function openConfiguration(options) {
    return accessor?.open(options);
  }
  return {
    actionInstance,
    accessor,
    refresh,
    setup,
    reset,
    openConfiguration,
    run,
    ...rest
  };
}

export { useActionInstance };
